import Tasks from "./Tasks";
import Orderbook from "./Orderbook";
import AddTaskBox from "./Add/AddTaskBox";
import Config from "./Config";
import TablesWrapper from "./TablesWrapper/TablesWrapper";
import IVRefTable from "../../Tables/Marketmaking/IVRefTable";

const Marketmaking = () => {
  return (
    <div className="flex flex-col justify-start items-start gap-6 px-4 mt-8 h-[90vh] overflow-y-auto">
      <div className="flex flex-row justify-start items-start gap-3 w-full h-auto">
        <div className="min-w-max w-full h-max">
          <Tasks />
        </div>
        <div className="w-min h-max flex flex-col justify-start items-start gap-3">
          <Orderbook />
          <div className="h-max w-full border">
            <IVRefTable />  
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full h-auto">
        <div className="flex flex-col justify-start items-start gap-3">
          <AddTaskBox />
          <Config />
        </div>
        <div className="w-full h-full flex flex-col justify-start items-start gap-3">
          <TablesWrapper />
        </div>
      </div>
    </div>
  );
};

export default Marketmaking;
